module.exports = __webpack_public_path__ + "static/media/executivefunction_elements.5a0937c0.png";